import type { TimelineGpuScene } from "../timeline/board/ChapterBoard/gpuScene";
import { computeSceneMotion } from "../timeline/scene/SceneMotion/motion";
import { timelineRailAxisY } from "../timeline/marker/MarkerMetrics/metrics";
import {
  TIMELINE_WORLD_HEIGHT_PX,
  TIMELINE_WORLD_WIDTH_PX,
} from "../timeline/view/WorldMetrics/metrics";
import { appendTimelineGrid } from "./grid-vertices";
import { packTimelineVertices } from "./pack-vertices";
import { appendCastRailMarks } from "./cast-marks";
import { appendRailBranches } from "./rail-branch-vertices";
import { appendSceneChangeMarks } from "./scene-marks";
import { appendTimelineRail } from "./rail-vertices";
import type { TimelineVertex } from "./vertex-primitives";
import { worldViewFromTransform } from "./world-to-canvas";

export function buildTimelineVertices(
  scene: TimelineGpuScene,
  playheadMs: number,
  canvasWidth: number,
  canvasHeight: number,
  viewportWidth: number,
  panX: number,
  panY: number,
  zoom: number,
  pixelRatio: number,
): Float32Array {
  const motion = computeSceneMotion(
    playheadMs,
    viewportWidth,
    scene.totalDurationMs,
  );
  const axisY = timelineRailAxisY();
  const view = worldViewFromTransform(
    panX,
    panY,
    zoom,
    canvasWidth,
    canvasHeight,
    TIMELINE_WORLD_WIDTH_PX,
    TIMELINE_WORLD_HEIGHT_PX,
  );
  const verts: TimelineVertex[] = [];

  appendTimelineGrid(verts, motion.gridScrollPx, axisY, view);
  const branches = scene.branches;
  appendTimelineRail(
    verts,
    motion.gridScrollPx,
    axisY,
    TIMELINE_WORLD_WIDTH_PX,
    view,
    branches.length === 0,
  );
  appendRailBranches(verts, branches, axisY, viewportWidth, view);
  appendSceneChangeMarks(
    verts,
    scene.sceneStarts,
    branches,
    axisY,
    viewportWidth,
    view,
  );
  appendCastRailMarks(
    verts,
    branches,
    axisY,
    playheadMs,
    motion.groupCenterX,
    view,
  );

  return packTimelineVertices(verts, pixelRatio).data;
}

export function countTimelineVertices(data: Float32Array): number {
  return data.length / 6;
}
